export default __webpack_public_path__ + "static/media/HT-single.d1cf9217.svg";